import * as client from "./client";
import * as googleClient from "./googleClient";

const ClientFactory = {
    getClient: (name, params) => {
        if (name === "Google") {
            googleClient.init(params);
            return googleClient;
        }
        return client;
    },
};

export default ClientFactory;
